import { Model } from '@vuex-orm/core';
import Dua from "./Dua";
import UnitPlanActivityDua from "./UnitPlanActivityDua";
import UnitPlan from "../../units/UnitPlan";
import UnitPlanActivityIe from "./UnitPlanActivityIe";
import Ie from "../objetive/Ie";
import UnitPlanActivityFile from "./UnitPlanActivityFile";
import UnitPlanComments from '../../units/UnitPlanComments';

export default class UnitPlanActivity extends Model {

  public static entity = 'unitplan_activities';

  public static fields() {
    return {
      id: this.number(0),
      order: this.number(0),
      unitplan_id: this.number(null),
      title: this.string(''),
      activityLer: this.string(''),
      activityEva: this.string(''),
      type_id: this.number(null),
      instrument_id: this.number(null),
      type: this.string(''),
      instrument: this.string(''),
      disabled: this.boolean(false),
      created_at: this.string(new Date().toISOString().substr(0, 10)),
      update_at: this.string(new Date().toISOString().substr(0, 10)),
      momentos: this.attr([]),
      pies: this.attr([]),
      //
      unitplan: this.belongsTo(UnitPlan, 'unitplan_id'),
      ies: this.belongsToMany(Ie, UnitPlanActivityIe, 'activity_id', 'ie_id'),
      files: this.hasMany(UnitPlanActivityFile, 'activity_id'),
      duas: this.belongsToMany(Dua, UnitPlanActivityDua, 'activity_id', 'dua_id'),
      comments: this.hasMany(UnitPlanComments, 'idPlanUnidadActividad'),
      fechaClase: this.string(new Date().toISOString().substr(0, 10)),
      semanaClase: this.attr([]),
      mesClase: this.string(''),

    };
  }
}
